import type { Ref } from 'vue';
import { watch } from 'vue';
import type { HekateDisplayForm } from '@onshape/www-inertia';
import { FieldHtmlNameUtil, FormIdUtil } from '@onshape/www-inertia';
import hekateBus from '../../../../../bus';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';
import type {
  FormSubmitResolution,
  HekateFormSubmitOnSuccess,
} from '../../../../../model/HekateFormSubmission';

/**
 * An initially hidden from that is displayed after a user signs up for a free
 * trial and is a hobbyist There are two forms the hidden "survey" form which is
 * shown after the main form if certain conditions are met.
 */
export default class SignupSurveyProgressiveProfile extends CommonPreFilledProgressiveProfile {
  /** "this" form, not be be confused by the initially shown form on the page */
  private surveyFormDefinition?: Ref<HekateDisplayForm>;

  public override realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    formDefinition.value.isHidden = true;
    this.surveyFormDefinition = formDefinition;
    hekateBus.addEventListener('form-successfully-submitted', this.successListener.bind(this));
  }

  /** Check if other form on the page that was submitted is a track form and handle it */
  private async successListener(evt: HekateFormSubmitOnSuccess) {
    const { formDefinition, formSubmitResolution } = evt.data;
    if (!formDefinition || !this.surveyFormDefinition) return;

    const isTrackedForm = [FormIdUtil.names.unifiedSignup].includes(formDefinition.id);
    if (!isTrackedForm) {
      return;
    }

    const resolution = await formSubmitResolution;
    if (!resolution) {
      return;
    }

    this.handleFreePlanSignup(formDefinition, resolution);
  }

  /** Handle the free plan signup form */
  private handleFreePlanSignup(
    formDefinition: HekateDisplayForm,
    resolution: FormSubmitResolution
  ) {
    if (!this.surveyFormDefinition) return;

    if (resolution.successActions.length === 0) return;
    const act = resolution.successActions[0];
    if (act?.procedure !== 'tellMeMoreAboutIt') {
      return;
    }

    const howDidYouHearAboutUsSurveyField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition: this.surveyFormDefinition,
      fieldName: FieldHtmlNameUtil.howDidYouHearAboutUs,
    });
    howDidYouHearAboutUsSurveyField.name = howDidYouHearAboutUsSurveyField.name.replace(
      '[SOURCE]',
      act.params.replacement
    );

    const howDidYouHearAboutUsConcatField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition: this.surveyFormDefinition,
      fieldName: FieldHtmlNameUtil.howDidYouHearAboutUsConcat,
    });

    watch(howDidYouHearAboutUsSurveyField, (newVal) => {
      if (newVal) {
        howDidYouHearAboutUsConcatField.val = `${act.params.replacement}, ${newVal.val}`;
      }
    });
    // set the email
    const email = ExternalUtil.noRefFindDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.email,
    }).val;
    const emailField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition: this.surveyFormDefinition,
      fieldName: FieldHtmlNameUtil.email,
    });

    emailField.componentName = 'hidden-field';
    emailField.val = email;

    this.surveyFormDefinition.value.isHidden = false;
  }

  public override onSuccess(): void {
    document.getElementById('signup-survey-tell-us-more')?.classList.add('d-none');
  }
}
